import { Link } from 'react-router-dom';
import { brandStats, principleList, testimonialList } from '@/mocks/site';
import { siteInfo } from '@/mocks/news';

export default function BrandIntro() {
  return (
    <section id="about" className="w-full scroll-mt-20">
      <div className="mx-auto w-full px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-background-300 px-3 py-1.5 text-xs font-label text-foreground-600">
              <i className="ri-information-line text-accent-400" />
              关于黑料爆料
            </span>
            <h2 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              不生产结论，
              <span className="text-primary-500">只把顺序排好</span>
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们不追逐耸动的标题，而是把公开可见的信息按时间与热度重新组织。
              每条内容都标注来源数量与可信状态，反转发生时在原条目内补充进展，让来龙去脉始终可追溯。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {siteInfo.updateNote}，配图统一使用抽象氛围图，不公开任何个人隐私信息。
            </p>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-200 px-5 py-3 text-sm font-label text-foreground-900 transition-colors hover:bg-background-300"
            >
              了解内容原则
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {brandStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-200 text-accent-400">
                  <i className={`${stat.icon} text-xl`} />
                </span>
                <p className="mt-4 font-heading text-3xl text-foreground-950">
                  {stat.value}
                  <span className="ml-0.5 text-base text-foreground-500">{stat.suffix}</span>
                </p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {principleList.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-300">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-base font-label text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <h3 className="flex items-center gap-3 font-heading text-2xl text-foreground-950">
            <i className="ri-chat-quote-line text-accent-400" />
            读者怎么说
          </h3>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonialList.map((item) => (
              <blockquote
                key={item.name}
                className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-500" />
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.quote}
                </p>
                <footer className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full">
                    <img
                      src={item.avatar}
                      alt={`${item.name} 头像`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span>
                    <span className="block text-sm font-label text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}